import { gql, useQuery, DocumentNode } from '@apollo/client';
import { Ownership } from '../../../types';

const GET_BORROWER_OWNERSHIPS: DocumentNode = gql`
  query GetBorrowerOwnerships($ownerId: String!) {
    GetBorrowerOwnerships(ownerId: $ownerId) {
      _id
      name
      lastname
      phone
      email
      state
      loans {
        _id
        loanData
      }
    }  
  }
`;

export const useGetBorrowerOwnerships = (vars: { ownerId?: string; skip?: boolean }) => {
  const result = useQuery<{ GetBorrowerOwnerships: Ownership[] }>(
    GET_BORROWER_OWNERSHIPS,
    {
      variables: { ownerId: vars?.ownerId },
      skip: vars?.skip || !vars?.ownerId,
      ...vars,
    }
  );
  
  return {
    ...result,
    data: result.data?.GetBorrowerOwnerships,
  };
};
